import { render, staticRenderFns } from "./CPLoginPrivacyFooter.vue?vue&type=template&id=a8365c3c&scoped=true&"
import script from "./CPLoginPrivacyFooter.vue?vue&type=script&lang=ts&"
export * from "./CPLoginPrivacyFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CPLoginPrivacyFooter.vue?vue&type=style&index=0&id=a8365c3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8365c3c",
  null
  
)

export default component.exports